const { default: axios } = require("axios");

const FormReserve = function () {

    const formReserve = function (e) {

        const form = $(this);
        var values = new FormData(this);

         var link = 'https://www.reservas.movinn.com.br/pt/search?from='+dateFormatBr(values.get("from"))+'&to='+dateFormatBr(values.get("to"))+'&persons='+values.get("persons");

        if(values.get("regions") != null){
            link = link + '&regions[]=' + values.get("regions");
        }

        window.open(link, '_blank').focus();
        e.preventDefault();
    }

    const showFieldsMobile = (el) => {
        el.closest('form').find('.row-mob-hidden').show();
    }

    const abaShow = (e) => {

        e.preventDefault();

        const _this = e.currentTarget;
        let abaSelected = _this.getAttribute('data-aba_reserve');

        $('.aba-reserve,.box-agenda article').removeClass('active');

        _this.classList.add('active');
        document.getElementById(abaSelected).classList.add('active');

    }

    const dateFormatBr = (dt) => {
        let newDt = dt.split('/');
        return `${newDt[2]}-${newDt[1]}-${newDt[0]}`
    }

    const abaToggle = (e) => {
        e.preventDefault();
        const _this = e.currentTarget;

        $(_this).closest('.box-agenda').toggleClass('active');
    }

    return {
        init: function () {
            $(document).on('submit', '.form-send-reserve', formReserve);

            // aba mobile
            $(document).on('click', '#box-aba-agendamento', abaToggle);

            if($(window).width() < 992) {
                $(document).on('change', '#filter-bairro', function(){
                    showFieldsMobile($(this));
                })
            }

        }
    }
}();

module.exports = FormReserve;